(() => {
  if (window.dfGuideSignupLoaded) return;
  window.dfGuideSignupLoaded = true;

  const keys = {
    success: 'df-guide-success',
    subscribed: 'df-guide-subscribed',
    pending: 'df-guide-pending',
    shown: 'df-acquisition-shown',
    dismissed: 'df-acquisition-dismissed'
  };

  const read = (store, key) => {
    try { return store.getItem(key); }
    catch { return null; }
  };

  const write = (store, key, value) => {
    try { store.setItem(key, value); }
    catch {}
  };

  const remove = (store, key) => {
    try { store.removeItem(key); }
    catch {}
  };

  const parse = value => {
    try { return JSON.parse(value); }
    catch { return null; }
  };

  const media = matchMedia('(min-width:750px)');
  let shown = false;
  let desktopReady = false;
  let mobileReady = false;
  let scrolledEnough = false;
  let previousFocus;

  function validGuide(value) {
    try {
      const url = new URL(value, location.origin);

      if (
        url.origin !== location.origin ||
        !/^https?:$/.test(url.protocol)
      ) return '';

      return url.href;
    } catch {
      return '';
    }
  }

  function close(root) {
    const dialog = root.querySelector('dialog');

    if (dialog?.open) dialog.close();

    root.hidden = true;
    write(localStorage, keys.dismissed, String(Date.now()));

    if (previousFocus?.isConnected) previousFocus.focus();
  }

  function show(source, manual = false) {
    const root = document.querySelector(
      '[data-df-signup="' + source + '"]'
    );

    if (!root) return;

    if (!manual) {
      if (
        shown ||
        read(sessionStorage, keys.shown) ||
        read(localStorage, keys.subscribed) ||
        root.dataset.suppressed === 'true'
      ) return;

      const dismissed = Number(
        read(localStorage, keys.dismissed) || 0
      );

      if (
        dismissed &&
        Date.now() - dismissed < 7 * 86400000
      ) return;

      const competing = document.querySelectorAll(
        '.overlay:not([hidden]),' +
        '.lightbox:not([hidden]),' +
        'dialog[open],' +
        '[data-df-menu-toggle][aria-expanded="true"]'
      );

      if (
        [...competing].some(el => el.getClientRects().length)
      ) return;
    }

    const dialog = root.querySelector('dialog');

    if (
      !dialog ||
      dialog.open ||
      typeof dialog.showModal !== 'function'
    ) return;

    previousFocus = document.activeElement;
    root.hidden = false;

    if (source === 'S02') {
      const header = document.querySelector('.header');
      const top = Math.max(
        12,
        Math.min(
          120,
          header?.getBoundingClientRect().bottom || 100
        )
      );

      root.style.setProperty('--df-flyout-top', top + 'px');
      dialog.show();
    } else {
      dialog.showModal();
    }

    shown = true;
    write(sessionStorage, keys.shown, '1');

    dialog.querySelector(
      '[data-df-native-success] a,input,button,a'
    )?.focus();
  }

  function successState(block, root) {
    return {
      title:
        block.querySelector('h3')?.textContent.trim() ||
        'Your bathroom reset is ready.',

      guide: validGuide(
        block.querySelector('a')?.getAttribute('href') ||
        root.dataset.dfGuideUrl ||
        ''
      )
    };
  }

  function displaySuccess(root, state) {
    const form = root.querySelector('form');

    if (!form || !state) return;

    const guide = validGuide(
      root.dataset.dfGuideUrl || state.guide || ''
    );

    if (!guide) return;

    const box = document.createElement('div');
    box.dataset.dfNativeSuccess = '';
    box.setAttribute('role', 'status');
    box.setAttribute('aria-live', 'polite');

    const title = document.createElement('h3');
    title.textContent =
      state.title || 'Your bathroom reset is ready.';

    const link = document.createElement('a');
    link.className = 'df-signup__button';
    link.href = guide;
    link.textContent = 'Open my free guide';

    box.append(title, link);
    form.replaceChildren(box);
  }

  function rememberSuccess(state) {
    write(
      localStorage,
      keys.success,
      JSON.stringify(state)
    );

    write(localStorage, keys.subscribed, '1');
    write(sessionStorage, keys.shown, '1');
  }

  function cleanUrl() {
    const url = new URL(location.href);
    url.searchParams.delete('customer_posted');

    if (/^#DFGuide-S0[124]$/.test(url.hash)) {
      url.hash = '';
    }

    history.replaceState(
      history.state,
      '',
      url.pathname + url.search + url.hash
    );
  }

  function mobileCheck() {
    if (
      !media.matches &&
      mobileReady &&
      scrolledEnough
    ) {
      show('S02');
    }
  }

  function scrollCheck() {
    const available =
      document.documentElement.scrollHeight - innerHeight;

    if (
      available > 0 &&
      scrollY / available >= 0.5
    ) {
      scrolledEnough = true;
    }

    mobileCheck();
  }

  function init() {
    const roots = [
      ...document.querySelectorAll('[data-df-signup]')
    ];

    const pending = parse(
      read(sessionStorage, keys.pending)
    );

    const hashSource = location.hash.match(
      /^#DFGuide-(S0[124])$/
    )?.[1];

    const posted = new URL(location.href)
      .searchParams.get('customer_posted') === 'true';

    // The URL alone is never treated as proof of success.
    const nativeRoot = roots.find(root =>
      root.querySelector('[data-df-native-success]')
    );

    let state = parse(
      read(localStorage, keys.success)
    );

    let returnSource = '';

    if (nativeRoot) {
      state = successState(
        nativeRoot.querySelector('[data-df-native-success]'),
        nativeRoot
      );

      rememberSuccess(state);

      returnSource =
        pending?.source || (posted ? hashSource : '');

      remove(sessionStorage, keys.pending);
      remove(sessionStorage, 'df-native-return');
      cleanUrl();
    }

    roots.forEach(root => {
      if (root.dataset.dfBound) return;
      root.dataset.dfBound = 'true';

      root.querySelector('[data-df-close]')
        ?.addEventListener('click', () => close(root));

      const dialog = root.querySelector('dialog');

      dialog?.addEventListener('cancel', event => {
        event.preventDefault();
        close(root);
      });

      dialog?.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close(root);
        }
      });

      // Remember successful signup in this browser.
      // Shopify remains authoritative for marketing consent.
      if (state) {
        displaySuccess(root, state);
      } else if (
        read(localStorage, keys.subscribed) === '1' &&
        root.dataset.dfGuideUrl
      ) {
        displaySuccess(root, {
          title: 'Your bathroom reset is ready.',
          guide: root.dataset.dfGuideUrl
        });
      }

      const form = root.querySelector('form');

      if (
        !form ||
        form.querySelector('[data-df-native-success]')
      ) return;

      const email = form.querySelector('[type="email"]');
      const status = form.querySelector('[data-df-status]');

      email?.addEventListener('invalid', () => {
        email.setCustomValidity(
          'Please enter a valid email address.'
        );

        if (status) {
          status.textContent =
            'Please enter a valid email address.';
        }
      });

      email?.addEventListener('input', () => {
        email.setCustomValidity('');
      });

      // Remember which popup submitted, including security redirects.
      form.addEventListener('submit', () => {
        write(
          sessionStorage,
          keys.pending,
          JSON.stringify({
            source: root.dataset.dfSignup
          })
        );
      }, true);

      form.addEventListener('submit', async event => {
        if (
          event.defaultPrevented ||
          form.dataset.nativeRetry === 'true'
        ) return;

        event.preventDefault();

        if (!form.reportValidity()) return;

        const button = form.querySelector('[type="submit"]');

        if (button) button.disabled = true;
        if (status) status.textContent = 'Submitting…';

        try {
          const response = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
            headers: {
              Accept: 'text/html'
            }
          });

          const doc = new DOMParser().parseFromString(
            await response.text(),
            'text/html'
          );

          const success = doc.getElementById(form.id)
            ?.querySelector('[data-df-native-success]');

          if (response.ok && success) {
            const confirmed = successState(success, root);

            rememberSuccess(confirmed);

            document.querySelectorAll('[data-df-signup]')
              .forEach(item => {
                displaySuccess(item, confirmed);
              });

            remove(sessionStorage, keys.pending);
            cleanUrl();

            // Keep the popup open with its success message.
            if (
              root.dataset.dfSignup !== 'S04' &&
              !root.querySelector('dialog')?.open
            ) {
              show(root.dataset.dfSignup, true);
            }

            root.querySelector('[data-df-native-success] a')
              ?.focus();

          } else if (
            /challenge|captcha/i.test(response.url) ||
            doc.querySelector(
              '[data-hcaptcha],.g-recaptcha,#shopify-challenge'
            )
          ) {
            form.dataset.nativeRetry = 'true';

            if (status) {
              status.textContent =
                "Please submit once more to complete Shopify's security check.";
            }

          } else {
            remove(sessionStorage, keys.pending);

            if (status) {
              status.textContent =
                "We couldn't submit this just now. Please try again.";
            }
          }

        } catch {
          remove(sessionStorage, keys.pending);

          if (status) {
            status.textContent =
              "We couldn't submit this just now. Please try again.";
          }

        } finally {
          if (button?.isConnected) button.disabled = false;
        }
      });
    });

    // Reopen the submitting popup after a native Shopify POST.
    if (returnSource && returnSource !== 'S04') {
      show(returnSource, true);

    } else if (!nativeRoot && pending?.source) {
      const failedRoot = roots.find(root =>
        root.dataset.dfSignup === pending.source
      );

      if (
        failedRoot?.querySelector('[data-df-status]')
          ?.textContent.trim()
      ) {
        if (pending.source !== 'S04') {
          show(pending.source, true);
        }

        remove(sessionStorage, keys.pending);
      }
    }
  }

  document.addEventListener('mouseout', event => {
    if (
      media.matches &&
      desktopReady &&
      event.relatedTarget === null &&
      event.clientY <= 0
    ) {
      show('S01');
    }
  });

  addEventListener('scroll', scrollCheck, {
    passive: true
  });

  setTimeout(() => {
    desktopReady = true;
  }, 20000);

  setTimeout(() => {
    mobileReady = true;
    scrollCheck();
  }, 35000);

  media.addEventListener('change', () => {
    document.querySelectorAll('[data-df-signup] dialog[open]')
      .forEach(dialog => {
        const root = dialog.closest('[data-df-signup]');

        if (
          (root.dataset.dfSignup === 'S01' && !media.matches) ||
          (root.dataset.dfSignup === 'S02' && media.matches)
        ) {
          close(root);
        }
      });

    mobileCheck();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();